import { render, staticRenderFns } from "./Rankings_Section_Header.vue?vue&type=template&id=4c5e30ca&"
import script from "./Rankings_Section_Header.vue?vue&type=script&lang=js&"
export * from "./Rankings_Section_Header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports